import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { changePreview } from '../../../../../../redux/product/product.actions';
import { activeProductImageSelector, currentImagesSelector } from '../../../../../../redux/product/product.selectors';
import { AllProductImages as AllProductImagesComponent } from './all-product-images';
const selectors = createStructuredSelector({
  images: currentImagesSelector,
  activeImage: activeProductImageSelector
});
const actions = dispatch => ({
  onChangeView: index => {
    if (index === null) {
      return;
    }
    dispatch(changePreview(index));
  }
});
const connector = connect(selectors, actions);
export const AllProductImages = connector(AllProductImagesComponent);